(function () {
    'use strict';

    angular.module('swif.ui')

    .directive('swifTrClickSetCurrent', swifTrClickSetCurrent)
    .directive('swifTableObjects', swifTableObjects)
    .directive('swifTable', swifTable);

    /**
    * @ngdoc directive
    * @name swif.ui:swifTrClickSetCurrent
    * @module swif.ui
    * @restrict E
    * @description set the item as current in the collection
    **/
    function swifTrClickSetCurrent () {
        return {
            restrict: 'A',
            scope: {
                swifTrClickSetCurrent: '=',
                collection: '='
            },
            link: function (scope, element) {
                element.addClass('link-trigger');
                element.click(function (event) {
                    if (_.contains(['A', 'BUTTON'], event.target.nodeName)) {
                        return;
                    }
                    if ($(event.target).parents('a,button').length > 0) {
                        return;
                    }
                    if (scope.collection.currentItem) {
                        if (scope.collection.currentItem.id === scope.swifTrClickSetCurrent.id) {
                            scope.collection.setCurrent();
                            scope.$apply();
                            return;
                        }
                    }
                    scope.collection.setCurrent(scope.swifTrClickSetCurrent);
                    scope.$apply();
                });
            }
        };
    }


    /**
    * @ngdoc directive
    * @name swif.ui:swifTableObjects
    * @module swif.ui
    * @restrict E
    * @description display objects as a table with editing support. Used in wizard & import
    **/
    function swifTableObjects (swif) {
        'ngInject';
        return {
            restrict: 'E',
            replace: true,
            require: 'ngModel',
            scope: {
                fields: '=',
                heads: '@',
                editable: '=?',
                contentType: '@'
            },
            templateUrl: 'partials/ui/table_objects.html',
            link: function (scope, element, attr, ngModel) {
                scope.editable = scope.editable || false;
                if (scope.contentType) {
                    swif.data.getModelFields(scope.contentType)
                    .then(function (modelFields) {
                        scope.modelFields = modelFields;
                    });
                }
                scope.getContentTypeFromModel = function (model) {
                    return swif.settings.getContentTypeFromModel(model).id;
                };
                scope.th = scope.heads.split(',');
                scope.deleteItem = function (item) {
                    var index = scope.data.indexOf(item);
                    scope.data.splice(index, 1);
                };
                ngModel.$render = function () {
                    scope.data = ngModel.$viewValue;
                };
            }
        };
    }

    /**
    * @ngdoc directive
    * @name swif.ui:swifTable
    * @module swif.ui
    * @description make table responsive and apply all needed class
    * @restrict A
    * @usage
    * <table swif-table></table>
    **/
    function swifTable () {
        return {
            restrict: 'A',
            link: function (scope, element, attributes) {
                element.addClass('table table-striped table-bordered table-hover table-vertical-align');
                if (attributes.noResponsive !== 'true') {
                    element.wrap('<div class="table-responsive"></div>');
                }
            }
        };
    }
})();